import { Box, Button, SxProps, Typography, useTheme } from "@mui/material";
import { Button as ButtonType } from "../../models/common.models";
import Image from "./Image";

interface ActionCardProps {
  imageSrc?: string;
  title?: string;
  subIconText?: string;
  button?: ButtonType;
  containerSx?: SxProps;
  handleButtonClick?: VoidFunction;
}

const ActionCard = ({
  imageSrc,
  title,
  button,
  containerSx,
  handleButtonClick,
  subIconText,
}: ActionCardProps) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        background: "white",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "178px",
        ...containerSx,
      }}
    >
      {imageSrc && (
        <Image
          sx={{
            marginBottom: "10px",
            width: "52px",
            height: "52px",
          }}
          src={imageSrc}
        />
      )}
      {subIconText && (
        <Typography
          sx={{
            fontWeight: "500",
            fontSize: "18px",
            color: theme.palette.text.primary,
            marginBottom: "5px",
          }}
        >
          {subIconText}
        </Typography>
      )}
      {title && (
        <Typography
          sx={{
            color: theme.palette.primary.main,
            fontWeight: "500",
            marginBottom: "10px",
          }}
        >
          {title}
        </Typography>
      )}
      {button && (
        <Button
          onClick={handleButtonClick}
          variant="outlined"
          sx={{
            color: theme.palette.text.primary,
            fontSize: "11px",
            borderRadius: "8px",
            borderColor: "#1A73E8",
          }}
        >
          {button.label}
        </Button>
      )}
    </Box>
  );
};

export default ActionCard;
